/**
 * Subitens da LC 116 que exigem informações de obra na NFS-e Nacional.
 * Deve ser mantida em sincronia com SUBITENS_OBRA_OBRIGATORIA no backend (PlugNotasMapperUtil).
 */
export const SUBITENS_OBRA_OBRIGATORIA = new Set([
  "070201", "070202", "070401", "070501", "070502",
  "070601", "070602", "070701", "070801", "071701",
  "071901", "141403", "141404",
]);

export const requiresObra = (nationalTaxCode?: string): boolean =>
  !!nationalTaxCode && SUBITENS_OBRA_OBRIGATORIA.has(nationalTaxCode.replace(/\D/g, ""));

export const TIPO_LOGRADOURO_OPTIONS = [
  { value: "Alameda", label: "Alameda" },
  { value: "Avenida", label: "Avenida" },
  { value: "Chácara", label: "Chácara" },
  { value: "Colônia", label: "Colônia" },
  { value: "Condomínio", label: "Condomínio" },
  { value: "Eqnp", label: "Eqnp" },
  { value: "Estância", label: "Estância" },
  { value: "Estrada", label: "Estrada" },
  { value: "Fazenda", label: "Fazenda" },
  { value: "Praça", label: "Praça" },
  { value: "Prolongamento", label: "Prolongamento" },
  { value: "Rodovia", label: "Rodovia" },
  { value: "Rua", label: "Rua" },
  { value: "Sítio", label: "Sítio" },
  { value: "Travessa", label: "Travessa" },
  { value: "Vicinal", label: "Vicinal" },
];
